import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { useQuery } from 'react-query';
import activeCarriersQueryKeys from './activeCarriersQueryKeys';

export const useActiveCarriersListQuery = (options = {} as any) => {
    const { authToken, currentAccountId } = useAuthSelector();
    const accountId = (options.accountId ?? currentAccountId) as string;
    const baseQueryKey = activeCarriersQueryKeys.list(accountId);
    const queryKey = options.params ? [...baseQueryKey, options.params] : baseQueryKey;
    const query = useQuery(queryKey, async () => sdk.active_carriers.list(accountId, { ...options, authToken }), {});

    return {
        ...query,
        queryKey,
    };
};

export default useActiveCarriersListQuery;
